import React from "react";
import { Gift, ExternalLink } from "lucide-react";
import { useContent } from "../context/ContentContext";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";

export default function Registry() {
  const { content } = useContent();
  const r = content?.registry;
  if (!r) return null;

  return (
    <div data-testid="registry-page">
      <PageHero overline="With Gratitude" title="Registry" />
      <div className="max-w-3xl mx-auto px-5 sm:px-8 py-20 text-center">
        <Reveal>
          <Gift className="mx-auto text-gold" size={34} />
          <p className="font-serif text-2xl sm:text-3xl leading-relaxed text-matte mt-6">{r.intro}</p>
          <p className="overline text-olive mt-6" data-testid="registry-gifts-encouraged">Monetary gifts only · warmly appreciated</p>
          <hr className="gold-divider my-10" />
          <div className="flex flex-wrap justify-center gap-5">
            {(r.links || []).map((l, i) => {
              const hasUrl = l.url && l.url.trim();
              const cls = "rounded-lg px-6 py-8 border transition-all duration-300 flex flex-col items-center gap-3 w-full sm:w-64";
              const inner = (
                <>
                  <span className="font-serif text-xl">{l.label}</span>
                  <ExternalLink size={16} className="opacity-70" />
                </>
              );
              return hasUrl ? (
                <a key={i} href={l.url} target="_blank" rel="noopener noreferrer"
                  className={`${cls} bg-olive text-soft-white border-olive hover:bg-olive-deep`} data-testid={`registry-link-${i}`}>{inner}</a>
              ) : (
                <div key={i} className={`${cls} bg-soft-white text-taupe border-taupe/40`} data-testid={`registry-placeholder-${i}`} title="Link coming soon">{inner}</div>
              );
            })}
          </div>
        </Reveal>
      </div>
    </div>
  );
}
